import React from 'react';
import "./Contact.css";
import { MdCall } from 'react-icons/md';
import {HiChatBubbleBottomCenter} from 'react-icons/hi2';
import {BsFillChatDotsFill} from 'react-icons/bs';

function Contact() {
  return (
    <section id="contact" className="c-wrapper">
        <div className="paddings innerWidth flexCenter c-container">
            {/* Left Side */}
            <div className="c-left flexColStart">
                <span className='violetText'>Our Contact</span>
                <span className='primaryText'>Contact Us At</span>
                <span className='secondaryText'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestias laudantium, iure quibusdam maiores vel iusto dolorum possimus. Dolorem debitis explicabo nobis ipsa aperiam quasi eum ut nesciunt porro voluptas.</span>

                <div className="flexColStart contactModes">
            {/* first row */}
            <div className="flexStart row">
              <div className="flexColCenter mode">
                <div className="flexStart">
                  <div className="flexCenter icon">
                    <MdCall size={25} />
                  </div>
                  <div className="flexColStart detail">
                    <span className="primaryText">Call</span>
                    <span className="secondaryText">+91 1234567890</span>
                  </div>
                </div>
                <div className="flexCenter button">Call now</div>
              </div>

              <div className="flexColCenter mode">
                <div className="flexStart">
                  <div className="flexCenter icon">
                    <BsFillChatDotsFill size={25} />
                  </div>
                  <div className="flexColStart detail">
                    <span className="primaryText">Chat</span>
                    <span className="secondaryText">+91 1234567890</span>
                  </div>
                </div>
                <div className="flexCenter button">Chat now</div>
              </div>
            </div>

            {/* second row */}
            <div className="flexStart row">
              <div className="flexColCenter mode">
                <div className="flexStart">
                  <div className="flexCenter icon">
                    <BsFillChatDotsFill size={25} />
                  </div>
                  <div className="flexColStart detail">
                    <span className="primaryText">Video Call</span>
                    <span className="secondaryText">+91 1234567890</span>
                  </div>
                </div>
                <div className="flexCenter button">Video Call now</div>
              </div>

              <div className="flexColCenter mode">
                <div className="flexStart">
                  <div className="flexCenter icon">
                    <HiChatBubbleBottomCenter size={25} />
                  </div>
                  <div className="flexColStart detail">
                    <span className="primaryText">Message</span>
                    <span className="secondaryText">+91 1234567890</span>
                  </div>
                </div>
                <div className="flexCenter button">Message now</div>
              </div>
            </div>
          </div>
        </div>

            {/* Right Side */}
            <div className="c-right">
                <div className="image-container">
                    <img src="./main3.jpeg" alt="contact image" />
                </div>
            </div>
        </div>
    </section>
  )
}

export default Contact
